module.exports = __webpack_public_path__ + "img/logo_white_lasa.27f330d.jpg";